import { database } from "..";
import Setting from "../model/settings";
import { Q } from "@nozbe/watermelondb";

export type APIAddress = {
  name?: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zip: string;
  phone?: string;
  email?: string;
  website?: string;
};

export function emptyAddress() {
  return {
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: "",
  };
}

export async function getDefaultTerms(): Promise<string> {
  const settings = await database
    .get<Setting>("settings")
    .query(Q.where("key", "terms"))
    .fetch();
  if (settings.length !== 0 && settings[0].value) {
    return settings[0].value;
  }
  return "";
}

export async function setDefaultTerms(terms: string): Promise<void> {
  await database.write(async () => {
    const termsSetting = await database
      .get<Setting>("settings")
      .query(Q.where("key", "terms"))
      .fetch();
    if (termsSetting.length !== 0 && termsSetting[0]) {
      termsSetting[0].update((s) => {
        s.value = terms;
      });
    } else {
      await database.get<Setting>("settings").create((s) => {
        s.key = "terms";
        s.value = terms;
      });
    }
  });
}

export async function getBusinessLogo(): Promise<string> {
  const settings = await database
    .get<Setting>("settings")
    .query(Q.where("key", "business_logo"))
    .fetch();
  if (settings.length !== 0 && settings[0].value) {
    return settings[0].value;
  }
  return "";
}

export async function setLogo(logo: string): Promise<void> {
  await database.write(async () => {
    const logoSetting = await database
      .get<Setting>("settings")
      .query(Q.where("key", "business_logo"))
      .fetch();
    if (logoSetting.length !== 0 && logoSetting[0]) {
      logoSetting[0].update((s) => {
        s.value = logo;
      });
    } else {
      await database.get<Setting>("settings").create((s) => {
        s.key = "business_logo";
        s.value = logo;
      });
    }
  });
}

export async function getBusinessAddress(): Promise<APIAddress> {
  const settings = await database
    .get<Setting>("settings")
    .query(Q.where("key", "business_address"))
    .fetch();
  if (settings.length !== 0 && settings[0].value) {
    console.log(settings[0])
    return JSON.parse(settings[0].value);
  }
  return {
    name: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zip: "",
    phone: "",
    email: "",
    website: ""
  };
}

export async function setBusinessAddress(businessAddress: APIAddress): Promise<void> {
  await database.write(async () => {
    const businessAddressSetting = await database
      .get<Setting>("settings")
      .query(Q.where("key", "business_address"))
      .fetch();
    if (businessAddressSetting.length !== 0 && businessAddressSetting[0]) {
      businessAddressSetting[0].update((s) => {
        s.value = JSON.stringify(businessAddress);
      });
    } else {
      await database.get<Setting>("settings").create((s) => {
        s.key = "business_address";
        s.value = JSON.stringify(businessAddress);      
      });
    }
  });
}

export async function getDefaultTaxId(): Promise<string> {
  const settings = await database
    .get<Setting>("settings")
    .query(Q.where("key", "default_tax_id"))
    .fetch();
  if (settings.length !== 0 && settings[0].value) {
    return settings[0].value;
  }
  return "";
}

export async function setDefaultTaxId(taxId: string): Promise<void> {
  await database.write(async () => {
    const taxIdSetting = await database
      .get<Setting>("settings")
      .query(Q.where("key", "default_tax_id"))
      .fetch();
    if (taxIdSetting.length !== 0 && taxIdSetting[0]) {
      taxIdSetting[0].update((s) => {
        s.value = taxId;
      });
    } else {
      await database.get<Setting>("settings").create((s) => {
        s.key = "default_tax_id";
        s.value = taxId;
      });
    }
  });
}